import React, { useState, useEffect } from 'react';
import { seedPersonasConfig, getPersonasConfig } from '../../utils/database';

const STORAGE_KEY = 'admin_biometric_enabled';

function getStored() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === 'false' ? false : true;
  } catch {
    return true;
  }
}

function setStored(value) {
  try {
    localStorage.setItem(STORAGE_KEY, value ? 'true' : 'false');
  } catch {
    /* ignore */
  }
}

function AdminSettings() {
  const [biometricEnabled, setBiometricEnabled] = useState(getStored);
  const [seedStatus, setSeedStatus] = useState('');
  const [personasExists, setPersonasExists] = useState(null);

  useEffect(() => {
    setBiometricEnabled(getStored());
    getPersonasConfig().then((data) => {
      setPersonasExists(!!data?.personas);
    }).catch(() => setPersonasExists(false));
  }, []);

  const handleSeedPersonas = async () => {
    setSeedStatus('Seeding...');
    try {
      await seedPersonasConfig();
      setSeedStatus('Done — config/personas seeded.');
      setPersonasExists(true);
      setTimeout(() => setSeedStatus(''), 4000);
    } catch (err) {
      setSeedStatus('Error: ' + (err.message || 'Failed'));
    }
  };

  const handleToggle = (e) => {
    const next = e.target.checked;
    setBiometricEnabled(next);
    setStored(next);
  };

  const hasCredentialsAPI =
    typeof navigator !== 'undefined' &&
    'credentials' in navigator &&
    typeof navigator.credentials.get === 'function';

  return (
    <div className="admin-settings card card--medium">
      <h2 className="admin-settings-title">Settings</h2>
      <div className="admin-settings-section">
        <div className="admin-settings-row">
          <div className="admin-settings-label-wrap">
            <span className="admin-settings-label">Enable Face ID / Touch ID for sign-in</span>
            <span className="admin-settings-hint text-secondary text-sm">
              When on, the admin login page shows “Sign in with Face ID / Touch ID” if your browser supports it.
            </span>
          </div>
          <label className="admin-settings-toggle" aria-label="Enable Face ID or Touch ID">
            <input
              type="checkbox"
              checked={biometricEnabled}
              onChange={handleToggle}
              disabled={!hasCredentialsAPI}
            />
            <span className="admin-settings-toggle-slider" />
          </label>
        </div>
        {!hasCredentialsAPI && (
          <p className="admin-settings-unsupported text-muted text-sm">
            Your browser does not support the Credential Management API, so this option has no effect.
          </p>
        )}
      </div>
      <div className="admin-settings-section" style={{ marginTop: '24px' }}>
        <div className="admin-settings-row">
          <div className="admin-settings-label-wrap">
            <span className="admin-settings-label">Personas Config (config/personas)</span>
            <span className="admin-settings-hint text-secondary text-sm">
              {personasExists === null ? 'Checking...' : personasExists ? 'Exists in Firestore.' : 'Not found — seed required.'}
            </span>
          </div>
          <button
            type="button"
            className="btn btn--primary"
            onClick={handleSeedPersonas}
            disabled={seedStatus === 'Seeding...'}
            style={{ whiteSpace: 'nowrap' }}
          >
            {seedStatus === 'Seeding...' ? 'Seeding...' : personasExists ? 'Re-seed' : 'Seed Now'}
          </button>
        </div>
        {seedStatus && seedStatus !== 'Seeding...' && (
          <p className="text-secondary text-sm" style={{ marginTop: '8px' }}>{seedStatus}</p>
        )}
      </div>
    </div>
  );
}

export default AdminSettings;
